<div class="code-icons">
  <a *ngIf="row.analogCount > 0" [routerLink]="['/catalog']" [queryParams]="{'keyword':analogTerm + ':' + row.flatCodes[environment.flatCodeAnalogAndRelated]}" i18n-nbTooltip="@@Analogs" nbTooltip="Аналоги товара">
    <tui-icon icon="copy"/>
  </a>
  <a *ngIf="row.relatedCount > 0" [routerLink]="['/catalog']" [queryParams]="{'keyword':relatedTerm + ':'+row.flatCodes[environment.flatCodeAnalogAndRelated]}" i18n-nbTooltip="@@Related" nbTooltip="Сопутствующие товары">
    <tui-icon icon="layers"/>
  </a>
  <a target="_blank" [routerLink]="['/product', row.url || row.syncUid]" nbTooltip="Открыть в новом окне" i18n-nbTooltip="@@ProductPage">
    <tui-icon icon="external-link"/>
  </a>
</div>
